import { render, staticRenderFns } from "./ProposalPc.vue?vue&type=template&id=be7aaf9a&scoped=true&"
import script from "./ProposalPc.vue?vue&type=script&lang=js&"
export * from "./ProposalPc.vue?vue&type=script&lang=js&"
import style0 from "./ProposalPc.vue?vue&type=style&index=0&id=be7aaf9a&prod&scoped=true&lang=scss&"
import style1 from "./ProposalPc.vue?vue&type=style&index=1&id=be7aaf9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be7aaf9a",
  null
  
)

export default component.exports